
// ************************************************
//
// JUST GOOGLE MAPS STUFF + RELATED BLOCKS
//
// ************************************************+

// a list of functions to init maps on API load
const gmapsAPICallbacks = [];

//google mpa styles object
const googleMapStyles = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#333333"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#212121"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#ededed"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#39c67b"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#333333"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#1b1b1b"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#1a1a1a"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#8a8a8a"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#575757"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#3c3c3c"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#39c67b"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#39c67b"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#4e4e4e"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#282828"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#2b2b2b"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#3d3d3d"
            }
        ]
    }
]
    ;


const LoadGoogleMapsAPI = () => {
    if (!document.getElementById("googleMapsScript")) {
        var script = document.createElement("script");
        script.src =
            "https://maps.googleapis.com/maps/api/js?key=" +
            googleAPIKey +
            "&libraries=places&callback=initMap";
        script.async = true;
        script.id = "googleMapsScript";

        // Attach your callback function to the `window` object
        window.initMap = function () {
            for (let i = 0; i < gmapsAPICallbacks.length; i++) {
                // get the current function getting looped
                const func = gmapsAPICallbacks[i];
                func();
            }
        };

        // Append the 'script' element to 'head'
        document.head.appendChild(script);
    }
};

const initGoogleMap = () => {
    // ---------
    // CONTACTS WITH MAP BLOCK - reused for vendors archive block
    // ---------

    let blocks = document.querySelectorAll(".js-map");

    if (blocks.length == 0) {
        return;
    }

    blocks.forEach((block) => {
        setupBlock(block);
    });

    function setupBlock(block) {
        // Create the script tag, set the appropriate attributes
        LoadGoogleMapsAPI();
        gmapsAPICallbacks.push(initMap);

        const mapFrame = block.querySelector(".js-mapframe");
        const markerData = JSON.parse(
            block.querySelector(".js-locationData").dataset.locations
        );

        let map;

        async function initMap() {
            //console.log(mapFrame);
            const { Map } = await google.maps.importLibrary("maps");
            map = new Map(mapFrame, {
                center: { lat: 48.845486, lng: 16.120908 },
                zoom: 14,
                disableDefaultUI: true,
                styles: googleMapStyles,
            });


            let openWindow = null;

            const markers = markerData.map((item) => {

                //console.log(item)
                let position = item.position;
                //fix type of position

                item.position.lat = parseFloat(item.position.lat);
                item.position.lng = parseFloat(item.position.lng);

                let name = item.name;
                let adress = item.adress;
                //console.log(item.name, item.adress, item.position);
                const marker = new google.maps.Marker({
                    position: position,
                    icon: themeURL + "/assets/img/map-pin2.svg",
                    map,
                    title: name,
                });

                const phoneLink = !item.phone.raw ? "" :
                    `<a class="af-p13 text-th-dark block" href="tel:${item.phone.raw}">${item.phone.label}</a>`;

                const mailLink = !item.mail.raw ? "" :
                    `<a class="af-p13 text-th-dark block" href="mailto:${item.mail.raw}">${item.mail.label}</a>`;

                const contentString = `
  <div class="p-1 ">
    <div class="af-h5 text-th-dark ">
      ${name}
    </div>
    <div class="af-p13 text-th-dark mt-3">
      ${adress}
      ${phoneLink}
      ${mailLink}
    </div>
  </div>`;




                const infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    ariaLabel: name,
                });


                marker.addListener("click", () => {
                    if (openWindow) {
                        openWindow.close();
                    }
                    infowindow.open({
                        anchor: marker,
                        map,
                    });
                    openWindow = infowindow;
                });
                /*
                                marker.addListener("click", () => {
                                    infowindow.close();
                                });*/

                return marker;
            });
            //console.log(markers);


            var bounds = new google.maps.LatLngBounds();
            for (var i = 0; i < markers.length; i++) {
                bounds.extend(markers[i].getPosition());
            }

            google.maps.event.addListenerOnce(
                map,
                "bounds_changed",
                function (event) {
                    //this.setZoom(map.getZoom() - 1);
                    if (this.getZoom() > 14) {
                        this.setZoom(14);
                    }
                }
            );
            map.fitBounds(bounds);
            map.setCenter(bounds.getCenter());
        }
    }
};

export { initGoogleMap }